import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../services/auth.service';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';


import { ProjectService, Project } from '../services/project.service';
// import { InvoiceService } from '../services/invoice.service';
// import { EwoService } from '../services/ewo.service';
import { RequestService } from '../services/request.service';
import { ActivityService, ActivityItem } from '../services/activity.service';
import { UserService } from '../services/user.service';
import { Router } from '@angular/router';
import { SelectedProjectService } from '../services/selectedproject.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule, MatTooltipModule, RouterModule],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
  title = 'Homepage';
  userName: string | null = null;
  firstName: string | null = localStorage.getItem('Firstname');
  lastName: string | null = localStorage.getItem('Lastname');
  company: string | null = null;
  today: string = new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });

  companyLogo: string | null = null;

  projectCount = 0;
  // overdueInvoiceCount = 0;
  // openEwoCount = 0;
  unansweredRequestCount = 0;
  closedRequestCount = 0;
  stageActionRequiredCount = 0;
  stageAcknowledgedCount = 0;
  stageInProgressCount = 0;
  stageCompleteCount = 0;

  recentActivity: ActivityItem[] = [];
  userCache = new Map<string, {username: string, firstname: string, lastname: string, profilePhoto: string}>();
  completedRequests: import('../services/request.service').Request[] = [];
  actionRequiredRequests: import('../services/request.service').Request[] = [];
  showResponseRateModal = false;
  allProjects: Project[] = [];
  selectedProjectName: string | null = null;

  
  constructor(
    private selectedProjectService: SelectedProjectService,
    private authService: AuthService,
    private projectService: ProjectService,
    // private invoiceService: InvoiceService,
    // private ewoService: EwoService,
    private requestService: RequestService,
    private activityService: ActivityService,
    private userService: UserService
    , private router: Router
  ) {}

  ///PJY 26 March 2026 - add outSource Roles
  private selectedProjectSub: Subscription | null = null;

  // Role-based visibility
  canViewProjects(): boolean {
    return this.authService.hasAnyRole(['Admin', 'PM', 'Offshore', 'Accounting', 'User','OutSourceAdmin','OutsourcePM','OutsourceUser']);
  }
  // canViewInvoices(): boolean {
  //   return this.authService.hasAnyRole(['Admin', 'PM', 'Offshore', 'Accounting', 'User']);
  // }
  // canViewEwos(): boolean {
  //   return this.authService.hasAnyRole(['Admin', 'PM', 'Offshore', 'Accounting', 'User']);
  // }
  canViewRequests(): boolean {
    return this.authService.hasAnyRole(['Admin', 'PM', 'Offshore', 'Accounting', 'User','OutSourceAdmin','OutsourcePM','OutsourceUser']);
  }
  canCreateProjects(): boolean {
    return !this.authService.isReadOnly() && this.authService.hasAnyRole(['Admin']);
  }
  // canCreateInvoices(): boolean {
  //   return this.authService.hasAnyRole(['Admin', 'Accounting']);
  // }
  // canCreateEwos(): boolean {
  //   return this.authService.hasAnyRole(['Admin', 'PM']);
  // }
  canCreateRequests(): boolean {
    return !this.authService.isReadOnly() && this.authService.hasAnyRole(['Admin']);
  }
  canCreateIQs(): boolean {
    return !this.authService.isReadOnly()
      && this.authService.hasAnyRole(['Offshore', 'User','OutSourceAdmin','OutsourcePM','OutsourceUser']);
  }
  canViewTimesheet(): boolean {
    return this.authService.hasAnyRole(['Admin', 'PM', 'Offshore', 'Accounting', 'User','OutSourceAdmin','OutsourcePM','OutsourceUser']);
  }

  ngOnInit(): void {
    // Subscribe to selected project changes so Home counts reflect the chosen project
    this.selectedProjectSub = this.selectedProjectService.selectedProject$.subscribe(proj => {
      if (proj) {
        this.loadCountsForProject(proj);
        this.loadRecentActivityForProject(proj);
        const found = this.allProjects.find(p => p.projectNumber === proj);
        this.selectedProjectName = found ? found.projectName : 'Project #' + proj;
      } else {
        this.loadGlobalCounts();
        this.loadRecentActivityForProject();
        this.selectedProjectName = null;
      }
    });

    this.userName = this.authService.getUserName();
    this.company = this.authService.getCompany();
    this.authService.companyLogo$.subscribe(url => this.companyLogo = url);
    this.projectService.getAllProjects().subscribe({
      next: (projects) => {
        this.allProjects = projects ?? [];
        this.projectCount = this.allProjects.length;
        // Resolve project name if a project was already selected before projects loaded
        const current = this.selectedProjectService.getSelectedProject();
        if (current && !this.selectedProjectName) {
          const found = this.allProjects.find(p => p.projectNumber === current);
          this.selectedProjectName = found ? found.projectName : 'Project #' + current;
        }
      },
      error: (err) => console.error('Failed to load projects:', err)
    });
    // initial load: attempt to use stored selected project, otherwise global
    const stored = this.selectedProjectService.getSelectedProject();
    if (stored) {
      this.loadCountsForProject(stored);
    } else {
      this.loadGlobalCounts();
    }
    

    // recent activities are loaded in response to selected project changes
  }

  ngOnDestroy(): void {
    this.selectedProjectSub?.unsubscribe();
  }

  private loadCountsForProject(projectNumber: number): void {
    // this.invoiceService.getInvoicesByProject(projectNumber).subscribe({ next: (invoices) => this.overdueInvoiceCount = (invoices ?? []).length, error: () => this.overdueInvoiceCount = 0 });
    // this.ewoService.getEwosByProject(projectNumber).subscribe({ next: (ewos) => this.openEwoCount = (ewos ?? []).length, error: () => this.openEwoCount = 0 });
    this.requestService.getRequestsByProject(projectNumber, { rfi: true, cdq: true, crfi: true, iq: true, risk: true }).subscribe({
      next: (reqs) => {
        const requests = reqs ?? [];
        this.unansweredRequestCount = requests.filter(r => r.status === 'Open').length;
        this.closedRequestCount = requests.filter(r => r.status === 'Closed').length;
        this.computeStageCounts(requests);
      },
      error: () => this.resetCounts()
    });
  }

  private loadRecentActivityForProject(projectNumber?: number): void {
    this.activityService.getRecentActivitiesByType().subscribe({
      next: (activities) => {
        const safeActivities = activities ?? [];
        // convert date strings to Date and filter by project if requested
        const processed = safeActivities.map(a => ({ ...a, activityDate: new Date(a.activityDate) } as ActivityItem));
        const filtered = projectNumber ? processed.filter(a => a.projectNumber == projectNumber) : processed;

        // fetch user info for any creators not cached
        filtered.forEach(activity => {
          if (activity.createdBy && !this.userCache.has(activity.createdBy)) {
            this.userService.getUserById(activity.createdBy).subscribe({ next: (user) => {
              this.userCache.set(activity.createdBy, { username: user.username, firstname: user.firstname || '', lastname: user.lastname || '', profilePhoto: user.profilePhoto || 'images/profile-placeholder.png' });
            }, error: () => {
              // Fallback: try username endpoint (accessible to all roles)
              this.userService.getUsernameById(activity.createdBy).subscribe({
                next: (username) => {
                  this.userCache.set(activity.createdBy, { username: username || activity.createdBy, firstname: '', lastname: '', profilePhoto: 'images/profile-placeholder.png' });
                },
                error: () => {
                  this.userCache.set(activity.createdBy, { username: activity.createdBy, firstname: '', lastname: '', profilePhoto: 'images/profile-placeholder.png' });
                }
              });
            }});
          }
        });

        this.recentActivity = filtered;
      },
      error: (err) => {
        console.error('Failed to load recent activity:', err);
        this.recentActivity = [];
      }
    });
  }

  private loadGlobalCounts(): void {
    // this.invoiceService.getOverdueInvoices().subscribe({ next: (invoices) => this.overdueInvoiceCount = (invoices ?? []).length, error: () => this.overdueInvoiceCount = 0 });
    // this.ewoService.getOpenEwos().subscribe({ next: (ewos) => this.openEwoCount = (ewos ?? []).length, error: () => this.openEwoCount = 0 });
    this.requestService.getAllRequests({ rfi: true, cdq: true, crfi: true, iq: true, risk: true }).subscribe({
      next: (requests) => {
        const reqs = requests ?? [];
        this.unansweredRequestCount = reqs.filter(r => r.status === 'Open').length;
        this.closedRequestCount = reqs.filter(r => r.status === 'Closed').length;
        this.computeStageCounts(reqs);
      },
      error: () => this.resetCounts()
    });
  }

  private computeStageCounts(requests: import('../services/request.service').Request[]): void {
    const answered = requests.filter(r => r.status === 'Answered');
    this.stageActionRequiredCount = answered.filter(r => !r.stage).length;
    this.stageAcknowledgedCount = answered.filter(r => r.stage === 'Acknowledged').length;
    this.stageInProgressCount = answered.filter(r => r.stage === 'In Progress').length;
    this.stageCompleteCount = answered.filter(r => r.stage === 'Complete').length;

    // Populate completed requests (stage = Complete), sorted by createdDate descending, limit 5
    this.completedRequests = answered
      .filter(r => r.stage === 'Complete')
      .sort((a, b) => new Date(b.createdDate ?? 0).getTime() - new Date(a.createdDate ?? 0).getTime())
      .slice(0, 5);

    // Populate action required requests (answered, no stage set), sorted by createdDate ascending (oldest first), limit 5
    this.actionRequiredRequests = answered
      .filter(r => !r.stage)
      .sort((a, b) => new Date(a.createdDate ?? 0).getTime() - new Date(b.createdDate ?? 0).getTime())
      .slice(0, 5);
  }

  get totalRequestCount(): number {
    return this.stageActionRequiredCount + this.stageAcknowledgedCount + this.stageInProgressCount + this.stageCompleteCount;
  }

  get responseRate(): number {
    const total = this.totalRequestCount;
    if (total === 0) return 0;
    const responded = this.stageAcknowledgedCount + this.stageInProgressCount + this.stageCompleteCount;
    return Math.round((responded / total) * 100);
  }

  get avgRequestsPerProject(): string {
    if (this.projectCount === 0) return '0';
    const avg = this.totalRequestCount / this.projectCount;
    return avg % 1 === 0 ? avg.toString() : avg.toFixed(1);
  }

  getStagePercentage(count: number): number {
    const total = this.totalRequestCount;
    if (total === 0) return 0;
    return Math.round((count / total) * 100);
  }

  private resetCounts(): void {
    this.unansweredRequestCount = 0;
    this.closedRequestCount = 0;
    this.stageActionRequiredCount = 0;
    this.stageAcknowledgedCount = 0;
    this.stageInProgressCount = 0;
    this.stageCompleteCount = 0;
  }

  getActivitiesByType(type: string): ActivityItem[] {
    return (this.recentActivity ?? []).filter(item => item.activityType === type);
  }

  getActivitiesByTypes(types: string[]): ActivityItem[] {
    return (this.recentActivity ?? []).filter(item => types.includes(item.activityType)).slice(0, 5);
  }

  navigateToActivity(item: ActivityItem) {
    // if (item.activityType === 'Invoice') {
    //   this.router.navigate(['/invoices']);
    // } else
    if (item.activityType === 'RFI' || item.activityType === 'IQ' || item.activityType === 'RISKS') {
      this.router.navigate(['/requests'], {
        queryParams: {
          project: item.projectNumber,
          ...(item.entityId ? { requestId: item.entityId } : { description: item.description })
        }
      });
    }
    // else if (item.activityType === 'EWO') {
    //   this.router.navigate(['/ewos']);
    // }
    else {
      if (item.projectNumber) {
        this.router.navigate(['/projects', item.projectNumber]);
      } else {
        this.router.navigate(['/']);
      }
    }
  }

  navigateToRequest(req: import('../services/request.service').Request) {
    this.router.navigate(['/requests'], {
      queryParams: {
        project: req.projectNumber,
        requestId: req.requestGuid
      }
    });
  }
}
